import { useMemo } from "react";
import { useFeatureFlags } from "../../feature-flags";
import { SelectOption } from "../../types/select";

export const useFeatureToggleSearchByOptions = (baseOptions: SelectOption[]) => {
  const { isFeatureEnabled } = useFeatureFlags();

  const searchByOptions = useMemo(() => {
    if (isFeatureEnabled("13676-search-by-owner-bu")) {
      return baseOptions;
    }
    return baseOptions.filter((option) => !["businessUnitId", "ownerName"].includes(option.value));
  }, [baseOptions, isFeatureEnabled]);

  return { searchByOptions };
};
